import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

import { type UiColorPalette, useUiColor } from "../../utils/UIContext";

type ColorProps = { $color: UiColorPalette };

const StyledRegular = styled.button<ColorProps>`
  background-color: ${({ $color }) => $color.solid};
  color: ${({ $color }) => $color.onSolid};
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;

  &:hover:not(.is-disabled) {
    background-color: ${({ $color }) => $color.strong};
    color: ${({ $color }) => $color.onSolid};
  }

  &:active:not(.is-disabled) {
    background-color: ${({ $color }) => $color.stronger};
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function RegularButton({ as, className, ...props }: Props) {
  const uiColor = useUiColor();
  return (
    <StyledRegular as={as} className={className} $color={uiColor} {...props} />
  );
}
